import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { CompassLogo } from "@/components/CompassLogo";
import { useLang } from "@/i18n/LanguageContext";
import { UI, t } from "@/i18n/translations";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ResetPasswordPage() {
  const { lang } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const A = UI.auth;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t(A.resetDone, lang));
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || UI.common.error[lang]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-paper px-5">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-6">
          <CompassLogo size={36} />
          <span className="font-display text-xl font-extrabold">Boussole</span>
        </div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight mb-4">{t(A.resetTitle, lang)}</h1>
        <form onSubmit={submit} className="space-y-3">
          <input
            data-testid="reset-password-input"
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t(A.password, lang)}
            className="w-full rounded-2xl border border-line bg-white px-3.5 py-3 text-sm outline-none focus:border-amber transition-colors"
          />
          <button
            data-testid="reset-submit-btn"
            type="submit"
            disabled={loading || !token}
            className="w-full rounded-2xl bg-amber text-ink font-bold py-3.5 flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            {t(A.resetTitle, lang)}
          </button>
        </form>
      </div>
    </div>
  );
}
